// Utilitário de backup automático a cada 60 minutos
// Armazena até 36 snapshots (36h de cobertura) no localStorage — 3 no celular
// Cada snapshot clona dados inteiros; limite baixo protege contra estouro de quota

const STORAGE_KEY      = 'kzerodiary_backup_historico';
// Hora do último automático em chave própria e minúscula. Antes o relógio era lido
// do próprio histórico: com a cota cheia o snapshot não gravava, o relógio nunca
// zerava e o upload pra nuvem disparava a cada minuto (o setInterval do App).
const ULTIMO_AUTO_KEY  = 'kzerodiary_backup_ultimo_auto';
// Celular tem ~5MB de localStorage (iPhone) e 36 cópias inteiras não cabem.
// A cópia que vale está na nuvem (Storage + dados_historico); aqui é reserva.
const EH_CELULAR       = typeof navigator !== 'undefined' && /iPhone|iPad|iPod|Android/i.test(navigator.userAgent || '');
const MAX_BACKUPS      = EH_CELULAR ? 3 : 36;
const AVISO_LIMITE     = 30; // avisa quando restam 6 slots
const INTERVALO_MINUTOS = 60;

function hoje() {
  return new Date().toISOString().split('T')[0];
}

// Carrega o histórico completo
export function carregarHistorico() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

// Salva um snapshot manual ou automático
// Retorna { snapshot, deletados: [] } — deletados = backups removidos por limite
// Automáticos NÃO são deduplicados — cada snapshot de 60 em 60 minutos é preservado
export function salvarSnapshot(dados, tipo = 'manual') {
  const historico = carregarHistorico();
  const dataHoje  = hoje();
  const agora     = new Date().toISOString();

  const novoSnapshot = {
    id:       Date.now(),
    data:     dataHoje,
    hora:     new Date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }),
    geradoEm: agora,
    tipo,
    dados:    JSON.parse(JSON.stringify(dados)), // deep clone
    totalRegistros: Object.values(dados).reduce((s, v) => s + (Array.isArray(v) ? v.length : 0), 0),
  };

  const listaFull    = [novoSnapshot, ...historico];
  const novoHistorico = listaFull.slice(0, MAX_BACKUPS);
  const deletados     = listaFull.slice(MAX_BACKUPS); // excedentes removidos

  if (String(tipo).startsWith('automatico')) {
    try { localStorage.setItem(ULTIMO_AUTO_KEY, agora); } catch { /* quota */ }
  }

  let gravou = false;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(novoHistorico));
    gravou = true;
  } catch (e) {
    // Quota estourada: descarta os mais antigos até caber
    let tentativa = novoHistorico;
    while (tentativa.length > 1) {
      tentativa = tentativa.slice(0, Math.floor(tentativa.length / 2));
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(tentativa));
        console.warn(`[autoBackup] quota estourada — reduzido para ${tentativa.length} snapshots`);
        gravou = true;
        break;
      } catch {}
    }
  }
  // Nem uma cópia coube: no celular o histórico antigo só ocupa a cota que o resto
  // do app precisa, então sai. No computador fica — é ponto de restauração dela.
  if (!gravou && EH_CELULAR) {
    try { localStorage.removeItem(STORAGE_KEY); } catch {}
  }
  return { snapshot: novoSnapshot, deletados };
}

// Retorna quantos backups serão deletados na próxima gravação automática
export function proximosDeletados() {
  const historico = carregarHistorico();
  const aposAdd = historico.length + 1;
  return aposAdd > MAX_BACKUPS ? historico.slice(MAX_BACKUPS - 1) : [];
}

// Retorna true se o histórico está próximo do limite (aviso preventivo)
export function proximoDoLimite() {
  return carregarHistorico().length >= AVISO_LIMITE;
}

// Quantos slots restam até o limite máximo
export function slotsRestantes() {
  return MAX_BACKUPS - carregarHistorico().length;
}

// Retorna o último snapshot automático ou null.
// Considera também 'automatico-parcial': o App grava esse tipo quando o
// snapshot contém anexos stripados (__b64__). Antes só 'automatico' contava,
// então uma sequência de snapshots parciais nunca "zerava" o relógio e o
// backup disparava a cada 60s (o intervalo do setInterval) em vez de 60min.
function ultimoAutomatico() {
  const historico = carregarHistorico();
  return historico.find(h => String(h.tipo || '').startsWith('automatico')) || null;
}

// Remove um snapshot pelo id
export function removerSnapshot(id) {
  const historico = carregarHistorico().filter(h => h.id !== id);
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(historico)); } catch { /* quota */ }
}

// Verifica se deve disparar o backup automático agora
// Retorna true se: nenhum automático ainda OU último automático foi há >= 60 min
export function deveDispararBackup() {
  const ultimo = ultimoAutomatico();
  let marcado = null;
  try { marcado = localStorage.getItem(ULTIMO_AUTO_KEY); } catch {}
  const quando = Math.max(
    ultimo ? new Date(ultimo.geradoEm).getTime() : 0,
    marcado ? new Date(marcado).getTime() || 0 : 0,
  );
  if (!quando) return true;
  const agora = Date.now();
  const minutos = (agora - quando) / 60000;
  return minutos >= INTERVALO_MINUTOS;
}

// Chave para controlar se o email do dia já foi enviado
const EMAIL_ENVIADO_KEY = 'kzerodiary_backup_email_enviado';

export function emailBackupHojeEnviado() {
  return localStorage.getItem(EMAIL_ENVIADO_KEY) === hoje();
}

export function marcarEmailEnviado() {
  localStorage.setItem(EMAIL_ENVIADO_KEY, hoje());
}
